import React from 'react'
import Modal from 'shared/library/molecules/Modal'
import styled from '@emotion/styled'
import useTranslation from 'next-translate/useTranslation'
import RemoveMembership from 'library/molecules/ModalContentRemoveMembership'
import {
  ModalConfig,
  ActiveModalProps,
  RecursiveOmitSetActiveModalId,
  MODAL_MIXINS
} from '../../../shared/library/molecules/Modal/Modal'
import { ModalContentRemoveMembershipProps } from '../ModalContentRemoveMembership/ModalContentRemoveMembership'
import ModalContentActiveVoucher, {
  ModalContentActiveVoucherInterface
} from '../ModalContentActiveVoucher'
import {
  generateModalTitleAuth,
  ModalAuthProps,
  MODAL_CONFIG_AUTH
} from 'library/molecules/ModalsAuth'

export enum MODAL_IDS {
  removeMembership = 'removeMembership',
  activeVoucher = 'activeVoucher'
}

export type MODAL_PROPS = RecursiveOmitSetActiveModalId<{
  [MODAL_IDS.removeMembership]: ModalContentRemoveMembershipProps
  [MODAL_IDS.activeVoucher]: ModalContentActiveVoucherInterface
}> &
  ModalAuthProps

export const MODAL_CONFIG: ModalConfig = {
  [MODAL_IDS.removeMembership]: {
    id: MODAL_IDS.removeMembership,
    Content: RemoveMembership
  },
  [MODAL_IDS.activeVoucher]: {
    id: MODAL_IDS.activeVoucher,
    Content: ModalContentActiveVoucher
  },
  ...MODAL_CONFIG_AUTH
}

const ModalsSchedulableDetails = ({
  activeModal,
  setActiveModalId,
  ...props
}: Omit<ActiveModalProps, 'activeModalId'>) => {
  const { t } = useTranslation('chargeable')

  const MODAL_TITLE = {
    [MODAL_IDS.removeMembership]: t('chargeable:remove-membership'),
    ...generateModalTitleAuth(t)
  }

  const ModalContent = activeModal?.Content ? activeModal?.Content : () => null
  const ModalTitle = activeModal?.id
    ? MODAL_TITLE[activeModal?.id as keyof typeof MODAL_TITLE]
    : undefined
  const isRemoveMembershipModal = activeModal?.id === 'removeMembership'

  return (
    <StyledModal
      isOpen={!!activeModal}
      activeModalId={activeModal?.id}
      modalTitle={ModalTitle}
      fullWindow={!isRemoveMembershipModal}
    >
      <ModalContent {...props} setActiveModalId={setActiveModalId} />
    </StyledModal>
  )
}

export default ModalsSchedulableDetails

const StyledModal = styled(Modal)(
  ({ theme, activeModalId }) =>
    activeModalId === MODAL_IDS.activeVoucher && MODAL_MIXINS.voucher(theme),
  ({ theme, activeModalId }) =>
    activeModalId === MODAL_IDS.removeMembership && MODAL_MIXINS.popup(theme)
)
